import { render } from "./Miga.vue?vue&type=template&id=64853c19"
import script from "./Miga.vue?vue&type=script&lang=js"
export * from "./Miga.vue?vue&type=script&lang=js"

import "./Miga.vue?vue&type=style&index=0&id=64853c19&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__